<script setup lang="ts">
import { ref } from 'vue'
import { PFlagItem, PItem, PList, PLoader, PMenu } from '@previo/design-system'

import { Locales, $t } from '@previo/core'
import { Color } from '@previo/codebooks'
import { crmLocaleManager } from '~/composables/translate'
import { useAuthAPI } from '~/http/auth/AuthAPI'
import { goToPrevioIDLogout } from '~/composables/PrevioID'

const authAPI = useAuthAPI()
const isDoingLogout = ref<boolean>(false)

const logout = () => {
  isDoingLogout.value = true

  authAPI.logout().finally(() => {
    isDoingLogout.value = false

    goToPrevioIDLogout()
  })
}

const langMenuOpen = ref<boolean>(false)
const changeLocale = (locale: Locales) => {
  crmLocaleManager.setLocale(locale)
  langMenuOpen.value = false
}
</script>

<template>
  <p-list>
    <p-item cy="password-language" :text="$t('Change language')">
      <p-menu v-model="langMenuOpen" anchor="bottom start" cy="select-language">
        <p-list>
          <p-flag-item
            cy="czech"
            :language-shortcut="Locales.CS"
            text="Čeština"
            clickable
            @click="changeLocale(Locales.CS)"
          />
          <p-flag-item
            cy="english"
            :language-shortcut="Locales.EN"
            text="English"
            clickable
            @click="changeLocale(Locales.EN)"
          />
          <p-flag-item
            cy="croatian"
            :language-shortcut="Locales.HR"
            text="Hrvatski"
            clickable
            @click="changeLocale(Locales.HR)"
          />
          <p-flag-item
            cy="hungary"
            :language-shortcut="Locales.HU"
            text="Magyar"
            clickable
            @click="changeLocale(Locales.HU)"
          />
          <p-flag-item
            cy="polish"
            :language-shortcut="Locales.PL"
            text="Polski"
            clickable
            @click="changeLocale(Locales.PL)"
          />
          <p-flag-item
            cy="german"
            :language-shortcut="Locales.DE"
            text="Deutsch"
            clickable
            @click="changeLocale(Locales.DE)"
          />
          <p-flag-item
            cy="romanian"
            :language-shortcut="Locales.RO"
            text="Românesc"
            clickable
            @click="changeLocale(Locales.RO)"
          />
          <p-flag-item
            cy="slovak"
            :language-shortcut="Locales.SK"
            text="Slovenčina"
            clickable
            @click="changeLocale(Locales.SK)"
          />
        </p-list>
      </p-menu>
    </p-item>
    <p-item class="p-flex p-items-center" cy="logout" :text="$t('Log out')" @click="logout">
      <p-loader v-if="isDoingLogout" :color="Color.PRIMARY" />
    </p-item>
  </p-list>
</template>
